(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-step]');
    if (!button) return;
    const input = button.closest('[data-quantity]').querySelector('input');
    if (!input || input.disabled) return;
    if (Number(button.dataset.step) > 0) input.stepUp(); else input.stepDown();
    input.dispatchEvent(new Event('change', {bubbles: true}));
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    const parent = select.closest('.ticket-card, .product-info');
    if (!parent || !option) return;
    const price = parent.querySelector('.ticket-price, [data-product-price]');
    const button = parent.querySelector('[data-add-button]');
    if (price) price.textContent = option.dataset.price;
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Buy tickets'; }
  });
})();
